import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { SessionService } from '../../../services/session.service';
import { BackendMenuJsonItem } from './sidebar.interfaces';

interface SidebarItem {
  label: string;
  route: string;
}

@Component({
  selector: 'app-dashboard-sidebar',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.scss',
})
export class DashboardSidebarComponent {
  @Input() collapsed = false;

  protected items: SidebarItem[] = [];

  constructor(private readonly router: Router, private readonly sessionSvc: SessionService) {}

  ngOnInit(): void {
    this.items = this.buildItems(this.sessionSvc.getMenuJson());
  }

  protected navigate(route: string): void {
    this.router.navigateByUrl(route);
  }

  private buildItems(menuJson: unknown[] | null): SidebarItem[] {
    if (!Array.isArray(menuJson)) {
      return [];
    }

    return menuJson
      .filter((item): item is BackendMenuJsonItem => this.isMenuItem(item))
      .filter((item) => item.is_read !== false && item.is_active !== false)
      .map((item) => ({
        label: item.menu_name?.trim() || item.menu_code?.trim() || 'Menu',
        route: this.normalizeRoute(item.route_path ?? item.menu_url),
        order: Number(item.display_order ?? item.order_by ?? item.serial_no ?? 0),
      }))
      .filter((item) => !!item.route)
      .sort((first, second) => first.order - second.order)
      .map(({ label, route }) => ({ label, route }));
  }

  private isMenuItem(value: unknown): value is BackendMenuJsonItem {
    return typeof value === 'object' && value !== null;
  }

  private normalizeRoute(route: string | null | undefined): string {
    const trimmedRoute = (route || '').trim();
    if (!trimmedRoute) {
      return '';
    }
    return trimmedRoute.startsWith('/') ? trimmedRoute : `/${trimmedRoute}`;
  }
}
